import { useTranslation } from 'react-i18next';
import { Input, Toggle } from '@salecycle/ui-component-library';
import { ConfigurationOption } from '../../components/ConfigurationOption';
import { InfoTooltip } from 'sections/onsite-campaigns/pages/CampaignEditor/components/InfoTooltip';
import { P } from '@salecycle/ui-component-library';
import styled from 'styled-components';

const OnClickQuestionText = styled(P)`
  font-size: 14px;
  color: #333;
  margin-bottom: ${({ theme }) => theme.designToken.spacing2};
`;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.designToken.spacing1};
  margin-bottom: ${({ theme }) => theme.designToken.spacing2};
`;

const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.designToken.spacing2};
`;

export type OnClickConfigurationProps = {
  value?: string;
  onChange: (value: string) => void;
  overrideFreqCaps?: boolean;
  onOverrideFreqCapsChange?: (overrideFreqCaps: boolean) => void;
  validationState?: 'error' | 'complete';
  validationMessage?: string;
};

export function OnClickConfiguration({
  value,
  onChange,
  overrideFreqCaps = true,
  onOverrideFreqCapsChange,
  validationState,
  validationMessage,
}: OnClickConfigurationProps) {
  const { t } = useTranslation('campaigns');

  const overrideToggleClicked = () => {
    if (onOverrideFreqCapsChange) {
      onOverrideFreqCapsChange(!overrideFreqCaps);
    }
  };

  return (
    <ConfigurationOption>
      <ToggleContainer>
        <Toggle
          ariaLabel="Override display frequency"
          label="Override display frequency"
          onChange={overrideToggleClicked}
          checked={overrideFreqCaps}
          margin={false}
        />
        <TooltipContainer>
          <InfoTooltip
            displayInline
            title={t('onsite.campaignOnClickTrigger.overrideFreqCapTooltipTitle')}
            content={t('onsite.campaignOnClickTrigger.overrideFreqCapTooltipContent')}
          />
        </TooltipContainer>
      </ToggleContainer>
      <OnClickQuestionText>{t('onsite.campaignOnClickTrigger.question')}</OnClickQuestionText>
      <Input
        tooltipComponent={
          <InfoTooltip
            title={t('onsite.campaignOnClickTrigger.tooltipTitle')}
            content={t('onsite.campaignOnClickTrigger.tooltipContent')}
            displayInline
          />
        }
        label={t('onsite.campaignOnClickTrigger.label')}
        value={value || ''}
        onChange={onChange}
        placeholder={t('onsite.campaignOnClickTrigger.placeholder')}
        validationState={validationState}
        validationMessage={validationMessage}
      />
    </ConfigurationOption>
  );
}
